// src/utils/facturaServiciosGenerator.js
// Generador de Factura de Servicios (Factamsa)

// Configuración de JEAN INFORMATICO
export const JEAN_INFORMATICO_CONFIG = {
  nombre: "JEAN INFORMATICO C.A",
  rif: "41023119-0",
  direccion: "C.C. LATIN CENTER PB LOCAL 01",
  telefono1: "04125696219",
  telefono2: "0416-7594723",
  ciudad: "ACARIGUA - PORTUGUESA",
  email: "jean.informatico@gmail.com",
  slogan: "Servicio Técnico Especializado",
  whatsapp: "04167594723",
  instagram: "@jeaninformatico",
  facebook: "Jean Informatico",
  tiktok: "@jeaninformatico"
};

/**
 * Formatear número con separadores de miles
 */
export const formatearNumero = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '0.00';
  return parseFloat(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Formatear precio en USD
 */
export const formatearPrecioUSD = (monto) => {
  if (monto === null || monto === undefined || isNaN(monto)) return '$0.00';
  return `$${parseFloat(monto).toFixed(2)}`;
};

/**
 * Formatear precio en Bolívares
 */
export const formatearPrecioBs = (monto) => {
  if (monto === null || monto === undefined || isNaN(monto)) return 'Bs 0,00';
  return `Bs ${parseFloat(monto).toFixed(2).replace('.', ',')}`;
};

/**
 * Número a letras (para montos)
 */
export const numeroALetras = (num) => {
  if (num === null || num === undefined || isNaN(num)) return 'CERO';
  
  const unidades = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
  const decenas = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
  const centenas = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];
  
  const numStr = parseFloat(num).toFixed(2);
  const partes = numStr.split('.');
  const entero = parseInt(partes[0]);
  const decimal = parseInt(partes[1] || 0);
  
  if (entero === 0 && decimal === 0) return 'CERO';
  
  // Convertir parte entera
  let texto = '';
  const miles = Math.floor(entero / 1000);
  const centenasParte = Math.floor((entero % 1000) / 100);
  const decenasParte = Math.floor((entero % 100) / 10);
  const unidadesParte = entero % 10;
  
  if (miles > 0) {
    texto += (miles === 1 ? 'MIL' : `${unidades[miles]} MIL`);
  }
  
  if (centenasParte > 0) {
    if (centenasParte === 1 && decenasParte === 0 && unidadesParte === 0) {
      texto += ' CIEN';
    } else {
      texto += ` ${centenas[centenasParte]}`;
    }
  }
  
  if (decenasParte > 0) {
    if (decenasParte === 1 && unidadesParte > 0) {
      const especiales = ['', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
      texto += ` ${especiales[unidadesParte]}`;
    } else {
      texto += ` ${decenas[decenasParte]}`;
      if (unidadesParte > 0) {
        texto += ` Y ${unidades[unidadesParte]}`;
      }
    }
  } else if (unidadesParte > 0) {
    texto += ` ${unidades[unidadesParte]}`;
  }
  
  // Agregar centavos
  if (decimal > 0) {
    texto += ` CON ${decimal.toString().padStart(2, '0')}/100`;
  }
  
  return texto.trim();
};

/**
 * Obtener fecha formateada
 */
export const formatearFechaFactura = (fechaISO) => {
  if (!fechaISO) return new Date().toLocaleDateString('es-ES', { 
    year: 'numeric', month: 'long', day: 'numeric' 
  });
  try {
    const d = new Date(fechaISO);
    return d.toLocaleDateString('es-ES', { 
      year: 'numeric', month: 'long', day: 'numeric' 
    });
  } catch {
    return fechaISO;
  }
};

/**
 * Generar número de factura único
 */
export const generarNumeroFactura = (numeroOrden) => {
  const fecha = new Date();
  const año = fecha.getFullYear();
  const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dia = fecha.getDate().toString().padStart(2, '0');
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `FS-${año}${mes}${dia}-${random}`;
};

/**
 * Generar HTML de la Factura de Servicios (Factamsa)
 */
export const generarHTMLFacturaServicios = (datos) => {
  const {
    orden,
    cliente,
    tecnico,
    detalles,
    numeroFactura,
    fechaFactura,
    subtotal,
    descuento,
    iva,
    total,
    observaciones,
    metodoPago,
    referenciaPago,
    tasaCambio,
    montoBs
  } = datos;

  const numeroOrden = orden.numeroOrden || orden.NumeroOrden || orden.idRecepcionEquipo || 'N/A';
  const totalLetras = numeroALetras(total || 0);

  // Construir filas de la tabla
  const filasDetalles = detalles.map((d, index) => {
    const nombre = d.nombre || d.descripcion || d.observaciones || 'Servicio';
    const cantidad = d.cantidad || 1;
    const precio = d.precioUnitarioUsd || d.precio || d.subtotalUsd || 0;
    const totalItem = d.total || d.subtotal || (precio * cantidad) || 0;
    
    return `
      <tr>
        <td style="padding: 6px 8px; border-bottom: 1px solid #e2e8f0; text-align: center;">${index + 1}</td>
        <td style="padding: 6px 8px; border-bottom: 1px solid #e2e8f0;">${nombre}</td>
        <td style="padding: 6px 8px; border-bottom: 1px solid #e2e8f0; text-align: center;">${cantidad}</td>
        <td style="padding: 6px 8px; border-bottom: 1px solid #e2e8f0; text-align: right;">${formatearPrecioUSD(precio)}</td>
        <td style="padding: 6px 8px; border-bottom: 1px solid #e2e8f0; text-align: right; font-weight: bold;">${formatearPrecioUSD(totalItem)}</td>
      </tr>
    `;
  }).join('');

  // Calcular IVA
  const ivaCalculado = ((subtotal - descuento) * (iva / 100)) || 0;

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Factura de Servicios - ${JEAN_INFORMATICO_CONFIG.nombre}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Arial', 'Helvetica', sans-serif;
      background: #f0f2f5;
      padding: 20px;
      display: flex;
      justify-content: center;
    }
    .factura-container {
      max-width: 850px;
      width: 100%;
      background: white;
      border-radius: 12px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.12);
      overflow: hidden;
    }
    
    /* HEADER CON DEGRADADO */
    .header-factura {
      background: linear-gradient(135deg, #1a3a5c 0%, #2d6a9f 100%);
      padding: 25px 35px;
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .header-izquierda .empresa-nombre {
      font-size: 26px;
      font-weight: 900;
      letter-spacing: -0.5px;
    }
    .header-izquierda .empresa-slogan {
      font-size: 13px;
      opacity: 0.8;
      margin-top: 2px;
      font-weight: 300;
    }
    .header-izquierda .empresa-info {
      font-size: 11px;
      opacity: 0.7;
      margin-top: 6px;
      line-height: 1.5;
    }
    .header-derecha {
      text-align: right;
    }
    .header-derecha .factura-titulo {
      font-size: 32px;
      font-weight: 900;
      letter-spacing: 3px;
      text-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }
    .header-derecha .factura-subtitulo {
      font-size: 12px;
      opacity: 0.7;
      font-weight: 300;
      letter-spacing: 1px;
    }
    .header-derecha .factura-numero {
      font-size: 16px;
      font-weight: bold;
      margin-top: 5px;
      background: rgba(255,255,255,0.15);
      padding: 4px 12px;
      border-radius: 4px;
      display: inline-block;
    }
    .header-derecha .factura-fecha {
      font-size: 12px;
      opacity: 0.8;
      margin-top: 4px;
    }
    
    /* CUERPO */
    .cuerpo-factura {
      padding: 25px 35px 20px;
    }
    
    /* DATOS DEL CLIENTE */
    .seccion-cliente {
      background: #f8fafc;
      border-radius: 8px;
      padding: 15px 20px;
      margin-bottom: 20px;
      border-left: 4px solid #2d6a9f;
    }
    .seccion-cliente .cliente-label {
      font-size: 10px;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 600;
    }
    .seccion-cliente .cliente-nombre {
      font-size: 18px;
      font-weight: 700;
      color: #1e293b;
      margin-top: 2px;
    }
    .seccion-cliente .cliente-datos {
      font-size: 13px;
      color: #475569;
      margin-top: 3px;
    }
    .seccion-cliente .orden-info {
      display: flex;
      gap: 30px;
      margin-top: 8px;
      font-size: 12px;
      color: #64748b;
    }
    .seccion-cliente .orden-info span strong {
      color: #1e293b;
    }
    
    /* TABLA DE SERVICIOS */
    .tabla-servicios {
      width: 100%;
      border-collapse: collapse;
      margin: 15px 0 20px;
      font-size: 13px;
    }
    .tabla-servicios thead th {
      background: #1e293b;
      color: white;
      padding: 10px 12px;
      text-align: left;
      font-weight: 600;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .tabla-servicios tbody tr:hover {
      background: #f8fafc;
    }
    .tabla-servicios tbody td {
      padding: 8px 12px;
      border-bottom: 1px solid #e2e8f0;
    }
    .tabla-servicios tfoot tr {
      font-weight: 700;
    }
    .tabla-servicios tfoot td {
      padding: 10px 12px;
      border-top: 2px solid #1e293b;
    }
    .tabla-servicios .text-right { text-align: right; }
    .tabla-servicios .text-center { text-align: center; }
    .tabla-servicios .text-bold { font-weight: 700; }
    .tabla-servicios .text-blue { color: #2d6a9f; }
    .tabla-servicios .text-green { color: #16a34a; }
    .tabla-servicios .text-red { color: #dc2626; }
    
    /* RESUMEN DE MONTOS */
    .resumen-montos {
      margin-top: 5px;
      display: flex;
      justify-content: flex-end;
    }
    .resumen-montos table {
      width: 280px;
      font-size: 13px;
    }
    .resumen-montos td {
      padding: 4px 8px;
    }
    .resumen-montos .total-label {
      font-weight: 700;
      color: #1e293b;
      font-size: 14px;
    }
    .resumen-montos .total-monto {
      font-size: 22px;
      font-weight: 900;
      color: #2d6a9f;
    }
    .resumen-montos .monto-linea {
      border-top: 1px solid #e2e8f0;
      padding-top: 8px;
    }
    
    /* TOTAL EN LETRAS */
    .total-letras {
      margin-top: 10px;
      padding: 10px 15px;
      background: #f1f5f9;
      border-radius: 6px;
      font-size: 13px;
      color: #1e293b;
      border-left: 3px solid #2d6a9f;
    }
    .total-letras strong {
      font-weight: 700;
    }
    
    /* OBSERVACIONES */
    .seccion-observaciones {
      margin-top: 15px;
      padding: 12px 15px;
      background: #fafafa;
      border-radius: 6px;
      border: 1px solid #e2e8f0;
    }
    .seccion-observaciones .obs-label {
      font-size: 10px;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 600;
    }
    .seccion-observaciones .obs-texto {
      font-size: 13px;
      color: #1e293b;
      margin-top: 4px;
      white-space: pre-wrap;
    }
    
    /* INFORMACIÓN DE PAGO */
    .seccion-pago {
      margin-top: 15px;
      display: flex;
      gap: 30px;
      flex-wrap: wrap;
      padding: 12px 15px;
      background: #f8fafc;
      border-radius: 6px;
      border: 1px solid #e2e8f0;
    }
    .seccion-pago .pago-item {
      font-size: 12px;
    }
    .seccion-pago .pago-item strong {
      color: #1e293b;
    }
    
    /* FOOTER */
    .footer-factura {
      background: #f8fafc;
      padding: 15px 35px;
      border-top: 1px solid #e2e8f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }
    .footer-factura .footer-texto {
      font-size: 11px;
      color: #64748b;
    }
    .footer-factura .footer-redes {
      display: flex;
      gap: 15px;
      font-size: 11px;
      color: #2d6a9f;
      font-weight: 600;
    }
    .footer-factura .footer-legal {
      font-size: 9px;
      color: #94a3b8;
      text-align: center;
      width: 100%;
      margin-top: 5px;
    }
    
    /* BOTONES DE CONTROL */
    .controles-impresion {
      padding: 15px 35px;
      background: white;
      border-top: 1px solid #e2e8f0;
      text-align: center;
      display: flex;
      justify-content: center;
      gap: 12px;
    }
    .controles-impresion button {
      padding: 10px 32px;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
    }
    .btn-imprimir {
      background: #2d6a9f;
      color: white;
    }
    .btn-imprimir:hover {
      background: #1a3a5c;
      transform: translateY(-1px);
    }
    .btn-cerrar {
      background: #e2e8f0;
      color: #475569;
    }
    .btn-cerrar:hover {
      background: #cbd5e0;
    }
    
    @media print {
      body { 
        background: white; 
        padding: 0; 
        display: block;
      }
      .factura-container { 
        box-shadow: none; 
        border-radius: 0; 
        max-width: 100%;
      }
      .header-factura {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .tabla-servicios thead th {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .controles-impresion { display: none; }
      .seccion-cliente { 
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .total-letras {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .seccion-pago {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .footer-factura {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        break-inside: avoid;
      }
    }
    
    @media (max-width: 600px) {
      .header-factura {
        flex-direction: column;
        text-align: center;
        padding: 20px;
      }
      .header-derecha {
        text-align: center;
        margin-top: 10px;
      }
      .cuerpo-factura {
        padding: 15px;
      }
      .footer-factura {
        flex-direction: column;
        text-align: center;
      }
      .resumen-montos {
        justify-content: center;
      }
      .seccion-cliente .orden-info {
        flex-direction: column;
        gap: 5px;
      }
    }
  </style>
</head>
<body>
<div class="factura-container">
  <!-- HEADER -->
  <div class="header-factura">
    <div class="header-izquierda">
      <div class="empresa-nombre">${JEAN_INFORMATICO_CONFIG.nombre}</div>
      <div class="empresa-slogan">${JEAN_INFORMATICO_CONFIG.slogan}</div>
      <div class="empresa-info">
        RIF: ${JEAN_INFORMATICO_CONFIG.rif} | ${JEAN_INFORMATICO_CONFIG.direccion}<br>
        ${JEAN_INFORMATICO_CONFIG.ciudad} | Tel: ${JEAN_INFORMATICO_CONFIG.telefono1}
      </div>
    </div>
    <div class="header-derecha">
      <div class="factura-titulo">FACTURA</div>
      <div class="factura-subtitulo">SERVICIOS TÉCNICOS</div>
      <div class="factura-numero">N° ${numeroFactura}</div>
      <div class="factura-fecha">${fechaFactura}</div>
    </div>
  </div>

  <!-- CUERPO -->
  <div class="cuerpo-factura">
    <!-- DATOS DEL CLIENTE -->
    <div class="seccion-cliente">
      <div class="cliente-label">DATOS DEL CLIENTE</div>
      <div class="cliente-nombre">${cliente?.nombre || cliente?.nombreCliente || 'C. FINAL'}</div>
      <div class="cliente-datos">
        ${cliente?.documento ? `Documento: ${cliente.documento} | ` : ''}
        Teléfono: ${cliente?.telefono || cliente?.telefonoCliente || 'N/D'} 
        ${cliente?.email ? `| Email: ${cliente.email}` : ''}
      </div>
      <div class="orden-info">
        <span><strong>N° Orden:</strong> #${numeroOrden}</span>
        <span><strong>Fecha Ingreso:</strong> ${formatearFechaFactura(orden.fechaIngreso || orden.FechaIngreso)}</span>
        <span><strong>Técnico:</strong> ${tecnico?.nombre || orden.nombreTecnico || 'N/D'}</span>
      </div>
    </div>

    <!-- TABLA DE SERVICIOS -->
    <table class="tabla-servicios">
      <thead>
        <tr>
          <th style="width:8%;">#</th>
          <th style="width:42%;">Descripción del Servicio / Producto</th>
          <th style="width:15%;" class="text-center">Cant.</th>
          <th style="width:17%;" class="text-right">Precio Unit.</th>
          <th style="width:18%;" class="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        ${filasDetalles || `
        <tr>
          <td colspan="5" style="padding:20px; text-align:center; color:#94a3b8;">
            No hay servicios registrados
          </td>
        </tr>
        `}
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4" class="text-right">SUBTOTAL</td>
          <td class="text-right text-bold">${formatearPrecioUSD(subtotal || 0)}</td>
        </tr>
        ${descuento > 0 ? `
        <tr>
          <td colspan="4" class="text-right text-red">DESCUENTO</td>
          <td class="text-right text-red">-${formatearPrecioUSD(descuento)}</td>
        </tr>
        ` : ''}
        <tr>
          <td colspan="4" class="text-right">I.V.A. (${iva || 16}%)</td>
          <td class="text-right">${formatearPrecioUSD(ivaCalculado)}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-right total-label">TOTAL A PAGAR</td>
          <td class="text-right total-monto">${formatearPrecioUSD(total || 0)}</td>
        </tr>
      </tfoot>
    </table>

    <!-- TOTAL EN LETRAS -->
    <div class="total-letras">
      <strong>Son:</strong> ${totalLetras} DÓLARES
      ${montoBs ? ` | <strong>Bs:</strong> ${formatearPrecioBs(montoBs)}` : ''}
      ${tasaCambio ? ` | <strong>Tasa:</strong> ${tasaCambio}` : ''}
    </div>

    <!-- OBSERVACIONES -->
    ${observaciones ? `
    <div class="seccion-observaciones">
      <div class="obs-label">📝 Observaciones</div>
      <div class="obs-texto">${observaciones}</div>
    </div>
    ` : ''}

    <!-- INFORMACIÓN DE PAGO -->
    ${metodoPago ? `
    <div class="seccion-pago">
      <div class="pago-item"><strong>Método de Pago:</strong> ${metodoPago}</div>
      ${referenciaPago ? `<div class="pago-item"><strong>Referencia:</strong> ${referenciaPago}</div>` : ''}
      <div class="pago-item"><strong>Total Pagado:</strong> ${formatearPrecioUSD(total || 0)}</div>
    </div>
    ` : ''}
  </div>

  <!-- FOOTER -->
  <div class="footer-factura">
    <div class="footer-texto">
      ${JEAN_INFORMATICO_CONFIG.direccion} - ${JEAN_INFORMATICO_CONFIG.ciudad}
    </div>
    <div class="footer-redes">
      ${JEAN_INFORMATICO_CONFIG.instagram} | ${JEAN_INFORMATICO_CONFIG.facebook}
    </div>
    <div class="footer-legal">
      Este documento es una factura de servicios técnicos. 
      Para cualquier reclamo presentarse dentro de los 15 días hábiles posteriores a la entrega.
    </div>
  </div>

  <!-- CONTROLES -->
  <div class="controles-impresion">
    <button class="btn-imprimir" onclick="window.print()">🖨️ Imprimir / Guardar PDF</button>
    <button class="btn-cerrar" onclick="window.close()">✖️ Cerrar</button>
  </div>
</div>

<script>
  // Auto-impresión opcional
  setTimeout(() => {
    if (confirm('¿Desea imprimir o guardar la factura como PDF?')) {
      window.print();
    }
  }, 500);
<\/script>
</body>
</html>`;
};

/**
 * Función para abrir la factura en nueva ventana
 */
export const abrirFacturaServicios = (datos) => {
  const html = generarHTMLFacturaServicios(datos);
  
  const ventana = window.open('', '_blank', 'width=900,height=700,menubar=yes,toolbar=yes,scrollbars=yes');
  if (!ventana) {
    alert('Por favor, permite ventanas emergentes para generar la factura');
    return false;
  }
  
  ventana.document.write(html);
  ventana.document.close();
  ventana.focus();
  return true;
};

export default {
  JEAN_INFORMATICO_CONFIG,
  formatearNumero,
  formatearPrecioUSD,
  formatearPrecioBs,
  numeroALetras,
  formatearFechaFactura,
  generarNumeroFactura,
  generarHTMLFacturaServicios,
  abrirFacturaServicios
};